import React, { useState, useMemo } from 'react';
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination,
  TableRow, TableSortLabel, IconButton, Collapse, Select, MenuItem, Button,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField,
  InputAdornment,
  Switch,
  Typography
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import axios from 'axios';
import { useSelector } from 'react-redux';

const headCells = [
  { id: 'transaction_id', label: 'شمیره' },
  { id: 'customer_name', label: 'نوم' },
  { id: 'customer_contact', label: 'د تلیفون شمیره' },
  { id: 'discount_amount', label: 'تخفبف' },
  { id: 'total_amount', label: 'ټوټل' },
];

export default function TransactionTable({ rows, setRefreshTrigger }) {
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('transaction_id');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openRows, setOpenRows] = useState({});
  const [defaulterCustomer, setDefaulterCustomer] = useState(0);
  const [selectedQuantities, setSelectedQuantities] = useState(1);
  const api = useSelector((state) => state.Api);
  const [adjustToLoan, setAdjustToLoan] = useState(false);
  // State for refund dialog
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [currentRefundItem, setCurrentRefundItem] = useState(null);
  const [currentRefundRow, setCurrentRefundRow] = useState(null);
  const [returnQuantity, setReturnQuantity] = useState(1);
  const [returnReason, setReturnReason] = useState('');
  const [eachItemRefundAm, setEachItemRefundAm] = useState(0.1);
  const step = currentRefundItem?.uniteType === 1 ? 1 : 0.1;


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'desc';
    setOrder(isAsc ? 'asc' : 'desc');
    setOrderBy(property);
  };
  const [filters, setFilters] = useState({
    transaction_id: '',
    customer_name: '',
    customer_contact: '',
    discount_amount: '',
    total_amount: '',
  });

  const toggleRow = (transactionId) => {
    setOpenRows((prev) => {
      const isOpen = prev[transactionId];
      // Close all rows first, then toggle current
      return { [transactionId]: !isOpen };
    });
  };
  // const toggleRow = (transactionId) => {
  //   setOpenRows((prev) => ({ ...prev, [transactionId]: !prev[transactionId] }));
  // };

  const handleSelectChange = (productId, value) => {
    setSelectedQuantities((prev) => ({ ...prev, [productId]: value }));
  };

  const handleRefundAmount = (product, returnQuantity) => {
    // //console.log(returnQuantity)
    const amCalc = product?.selling_price * returnQuantity
    setEachItemRefundAm(amCalc)
  };

  const calculateRefundAmount = (product, row) => {
    // //console.log(product, row)
    // //console.log(selectedQuantities)
    const quantity = selectedQuantities[product.product_id] || product.stock_quantity;

    // If there's no discount, simply return the proportional amount
    if (row.discount_amount <= 0) {
      return (quantity * product.selling_price).toFixed(2);
    }

    // For single product transactions (even with fractional quantities)
    if (row.inCartProducts.length === 1) {
      const refund = quantity * (product.selling_price - (row.discount_amount / product.stock_quantity));
      return Math.max(0, refund).toFixed(2);
    }

    // For multiple products with fractional quantities
    const itemContribution = (product.selling_price * product.stock_quantity) / row.total_amount;
    const itemDiscount = row.discount_amount * itemContribution;
    const refundAmount = quantity * (product.selling_price - (itemDiscount / product.stock_quantity));

    return Math.max(0, refundAmount).toFixed(2);
  };

  const refundedAmount = (product, transId, row) => {
    if (transId === row.transaction_id) {
      const refundedItems = row.inCartProducts.filter(item =>
        item.product_id === product.product_id && item.stock_quantity <= -1
      );

      if (refundedItems.length > 0) {
        const totalRefunded = refundedItems.reduce((sum, item) => sum + item.return_amount, 0);
        return totalRefunded.toFixed(2);
      }
    }
    return null;
  };

  const showDefaulters = async (customerID) => {
    const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
    try {
      const response = await axios.post(api.showDefaulterCustomer, { customerID: customerID }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      });
      if (response.status === 200) {
        //console.log(response.data)
        setDefaulterCustomer(response.data)
      }
    } catch (err) {
      console.error('Error fetching suppliers:', err);
    }
  };

  const openRefundDialog = (product, row) => {
    //console.log(row)
    // return false;
    handleRefundAmount(product, product?.stock_quantity)
    showDefaulters(row.customer_id)
    setCurrentRefundItem(product);
    setCurrentRefundRow(row);
    setReturnQuantity(product?.stock_quantity); // Reset to default quantity
    setReturnReason(''); // Reset reason
    setRefundDialogOpen(true);
  };

  const closeRefundDialog = () => { 
    setRefundDialogOpen(false);
    setCurrentRefundItem(null);
    setCurrentRefundRow(null);
  };

  const handleReturnQuantityChange = (event, item) => {
    //console.log(item)
    const value = parseFloat(event.target.value);
    const maxQuantity = currentRefundItem?.stock_quantity || 1;
    let selectedQauntity = 0.1
    if (!isNaN(value) && value > 0 && value <= maxQuantity) {
      setReturnQuantity(value);
      selectedQauntity = value
    } else if (value > maxQuantity) {
      // If entered value exceeds max quantity, set to max
      setReturnQuantity(maxQuantity);
      selectedQauntity = maxQuantity
    } else if (value <= 0) {
      // If entered value is zero or negative, set to minimum (0.1)
      setReturnQuantity(0.1);
    }
    handleRefundAmount(item, selectedQauntity)
  };

  const doRefund = async () => {
    if (!currentRefundItem || !currentRefundRow) return;
    //console.log(currentRefundItem)
    //console.log(currentRefundRow)
    const refundAmount = eachItemRefundAm.toFixed(2);
    let updateAveragePrice = parseFloat(currentRefundItem?.historical_average_price)
    let previousQuantity = parseFloat(currentRefundItem?.remaining_quantity)
    //console.log(updateAveragePrice, previousQuantity)
    if (previousQuantity >= 0) {
      const fullPrvPurchase = updateAveragePrice * previousQuantity
      const fullCurrentReturn = parseFloat(currentRefundItem?.average_cost_per_item) * parseFloat(returnQuantity)
      updateAveragePrice = (fullPrvPurchase + fullCurrentReturn) / (previousQuantity + parseFloat(returnQuantity))
      //console.log(previousQuantity, parseFloat(returnQuantity))
      //console.log(fullPrvPurchase,  fullCurrentReturn, updateAveragePrice)
    }

    const adjustHigherBalance = (parseFloat(refundAmount) > (parseFloat(defaulterCustomer?.net_balance )) && (parseFloat(defaulterCustomer?.net_balance) != 0))
    const extraAmount = (parseFloat(refundAmount) - (parseFloat(defaulterCustomer?.net_balance)))
    //console.log(refundAmount)
    //console.log(defaulterCustomer)

    let payload = {
      transaction_id: currentRefundRow.transaction_id,
      product_id: currentRefundItem.product_id,
      quantity_returned: returnQuantity,
      reason: returnReason || 'No reason provided',
      refund_amount: adjustHigherBalance ? parseFloat(defaulterCustomer?.net_balance) : refundAmount,
      adjustToLoan: adjustToLoan ? 'CASH' : defaulterCustomer?.net_balance === 0 ? 'CASH' : 'ADJUST',
      customer_id: defaulterCustomer?.customerID,
      productInfo: currentRefundItem,
      newAveragePrice: updateAveragePrice
    };
    //console.log(payload)
    //  return false
    const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
    try {
      const response = await axios.post(api.refundProcess, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      });
      if (response.status === 200) {
        if (adjustHigherBalance) {
          const adjustExtaPay = {
            amount: extraAmount,
            customer_id: currentRefundRow.customer_id,
            customerName: currentRefundRow.customer_name,
            payment_method: 'CASH_ADJUST_EXTRA',
            transaction_id: currentRefundRow.transaction_id,
          }
          adjustExtraAmount(adjustExtaPay)
        }
        else {
          setRefreshTrigger(prev => !prev);
          closeRefundDialog();
        }
        sessionStorage.removeItem('Products');
      }
    } catch (err) {
      console.error('Error processing refund:', err);
    }
  };

  const adjustExtraAmount = async (payload) => {
    //console.log('refundadjsutment is calling')
    const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
    try {
      const response = await axios.post(api.refundAdjustment, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      });
      if (response.status === 200) {
        setRefreshTrigger(prev => !prev);
        closeRefundDialog();
      }
    } catch (err) {
      console.error('Error processing refund:', err);
    }
  }
  const filteredRows = useMemo(() => {
    return rows
      .filter((row) =>
        Object.keys(filters).every((key) =>
          String(row[key] || '').toLowerCase().includes(String(filters[key] || '').toLowerCase())
        )
      )
      .sort((a, b) => {
        const aValue = a[orderBy] || '';
        const bValue = b[orderBy] || '';
        return order === 'asc'
          ? aValue < bValue ? -1 : 1
          : aValue > bValue ? -1 : 1;
      });
  }, [rows, filters, order, orderBy]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Safe quantity options generator
  const getQuantityOptions = (maxQuantity) => {
    const safeMax = Math.max(1, Math.min(maxQuantity, 100)); // Limit to 1-100
    return Array.from({ length: safeMax }, (_, i) => i + 1);
  };

  // Add this helper function to calculate refund totals
  // Updated calculateRefundTotals function
  const calculateRefundTotals = (product, row) => {
    // Get all items for this product in the transaction
    const allItems = row.inCartProducts.filter(
      item => item.product_id === product.product_id
    );

    // Separate purchased and refunded items
    const purchasedItems = allItems.filter(
      item => item.quantity_sold > 0
    );

    const refundedItems = allItems.filter(
      item => item.quantity_sold < 0
    );

    // Calculate totals
    const originalQuantity = purchasedItems.reduce(
      (sum, item) => sum + Math.abs(item.quantity_sold), 0
    );

    const totalRefundedQuantity = refundedItems.reduce(
      (sum, item) => sum + Math.abs(item.quantity_sold), 0
    );

    const totalRefundedAmount = refundedItems.reduce(
      (sum, item) => sum + Math.abs(item.total_price), 0
    );

    const remainingQuantity = originalQuantity - totalRefundedQuantity;
    // //console.log(totalRefundedQuantity)
    return {
      originalQuantity,
      totalRefundedQuantity,
      totalRefundedAmount,
      remainingQuantity,
      refundedItems,
      canRefund: remainingQuantity > 0
    };
  };



  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }}>
            <TableHead>
              <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id}>
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={(event) => handleRequestSort(event, headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                  <TableCell key={`filter-${headCell.id}`}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="standard"
                      value={filters[headCell.id]}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          [headCell.id]: e.target.value,
                        }))
                      }
                      placeholder={`لټون...`}
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>


            <TableBody>
              {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                <React.Fragment key={row.transaction_id}>
                  <TableRow>
                    <TableCell>
                      <IconButton onClick={() => toggleRow(row.transaction_id)}>
                        {openRows[row.transaction_id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell>{row.transaction_id}</TableCell>
                    <TableCell>{row.customer_name}</TableCell>
                    <TableCell>{row.customer_contact}</TableCell>
                    <TableCell>{row.discount_amount}</TableCell>
                    <TableCell>{row.total_amount}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={6} sx={{ py: 0 }}>
                      <Collapse in={openRows[row.transaction_id]} timeout="auto" unmountOnExit>
                        <Box sx={{ m: 2 }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Product</TableCell>
                                <TableCell>Model</TableCell>
                                <TableCell>Quantity x Price</TableCell>
                                {/* <TableCell>Quantity</TableCell> */}
                                <TableCell>Refunded</TableCell>
                                <TableCell>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Object.values(
                                row.inCartProducts.reduce((acc, product) => {
                                  // Only show products that were originally purchased (not refund entries)
                                  if (product.quantity_sold > 0 && !acc[product.product_id]) {
                                    acc[product.product_id] = { ...product };
                                  }
                                  return acc;
                                }, {})
                              ).map((product) => {
                                const refundInfo = calculateRefundTotals(product, row);

                                return (
                                  <TableRow key={`${row.transaction_id}-${product.product_id}`}>
                                    <TableCell>{product.product_name}</TableCell>
                                    <TableCell>{product.product_code} <br /> {product.batchnumber}</TableCell>
                                    <TableCell>
                                      <Box display="flex" flexDirection="column">
                                        <span>
                                          {/* {refundInfo.originalQuantity.toFixed(2)} × {parseFloat(product?.selling_price?.toFixed(2))}  */}

                                          {refundInfo.originalQuantity.toFixed(2)} × {parseFloat(product?.selling_price)} =  {refundInfo.originalQuantity * product?.selling_price}
                                        </span>
                                        {/* {refundInfo.totalRefundedQuantity > 0 && (
                        <span style={{ color: 'red', fontSize: '0.9rem' }}>
                            Remaining: -{refundInfo.totalRefundedQuantity.toFixed(2)}
                        </span>
                    )} */}
                                        {refundInfo.totalRefundedQuantity > 0 && (
                                          <span style={{ color: 'red', fontSize: '0.9rem' }}>
                                            Refunded: -{refundInfo.totalRefundedQuantity.toFixed(2)}
                                          </span>
                                        )}
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Box display="flex" flexDirection="column">
                                        {refundInfo.totalRefundedAmount > 0 && (
                                          <span style={{ color: 'red' }}>
                                            Amount: -{refundInfo.totalRefundedAmount.toFixed(2)}
                                          </span>
                                        )}
                                        {refundInfo.refundedItems.map((refund, idx) => (
                                          <span key={idx} style={{ color: 'gray', fontSize: '0.8rem' }}>
                                            • {new Date(refund.created_at).toLocaleDateString()}:
                                            -{Math.abs(refund.quantity_sold).toFixed(2)} units
                                          </span>
                                        ))}
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      {refundInfo.canRefund ? (
                                        <Button
                                          variant="contained"
                                          color="secondary"
                                          size="small"
                                          disabled= "true"
                                          onClick={() => openRefundDialog({
                                            ...product,
                                            stock_quantity: refundInfo.remainingQuantity
                                          }, row)}
                                        >
                                          Refund
                                        </Button>
                                      ) : (
                                        <span style={{ color: 'green' }}>Fully Refunded</span>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Rows per page:"
        />
      </Paper>

      {/* Refund Dialog */}
      <Dialog open={refundDialogOpen} onClose={closeRefundDialog}>
        <DialogTitle> Refund Process</DialogTitle>
        <DialogContent>
          {currentRefundItem && currentRefundRow && (
            <>
              <DialogContentText>
                {currentRefundRow.customer_name} --
                {currentRefundRow.customer_contact}
              </DialogContentText>


              <Box sx={{ mt: 2 }}>
                <TextField
                  label="Return Quantity"
                  type="number"
                  fullWidth
                  value={returnQuantity}
                  onChange={(e) => handleReturnQuantityChange(e, currentRefundItem)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => {
                            const newValue = Math.max(
                              parseFloat(returnQuantity) - step,
                              step
                            );
                            setReturnQuantity(newValue.toFixed(2));
                            handleRefundAmount(currentRefundItem, newValue);
                          }}
                        >
                          <KeyboardArrowDownIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() => {
                            const newValue = Math.min(
                              parseFloat(returnQuantity) + step,
                              currentRefundItem.stock_quantity
                            );
                            setReturnQuantity(newValue.toFixed(2));
                            handleRefundAmount(currentRefundItem, newValue);
                          }}
                        >
                          <KeyboardArrowUpIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                    inputProps: {
                      min: step,
                      max: currentRefundItem.stock_quantity,
                      step: step
                    }
                  }}
                  sx={{ mb: 2 }}
                />

                <TextField
                  label="د واپسی دلیل "
                  fullWidth
                  multiline
                  rows={3}
                  value={returnReason}
                  onChange={(e) => setReturnReason(e.target.value)}
                  placeholder="د بیاکتنې دلیل ولیکئ..."
                />
              </Box>

              <Box sx={{ mt: 2 }}>
                <DialogContentText>
                  <strong>مبلغ:</strong> {eachItemRefundAm.toFixed(2)} افغانۍ
                </DialogContentText>
              </Box>
              <Box>
                <DialogContentText>
                  <span>پور</span>
                  <span style={{ color: defaulterCustomer?.net_balance < 0 ? 'red' : 'green', fontWeight: 'bold', fontSize: '18px' }}>
                    {defaulterCustomer?.net_balance?.toFixed(2)}
                  </span>
                  <span>افغانۍ</span>
                </DialogContentText>
              </Box>
              {defaulterCustomer?.net_balance < 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1 }}>

                  <Typography style={{ fontSize: '15px' }} variant="loanAm">
                    {/* {adjustToLoan ? 
                "واپسی په قرض کی حساب شی" : 
                " یا په قرض کی حساب نه شی"}  */}
                    <span>یا  نغدی ورکو</span>
                  </Typography>
                  <Switch
                    checked={!adjustToLoan}
                    onChange={() => setAdjustToLoan(!adjustToLoan)}
                    color="secondary"
                  />
                  <Typography style={{ fontSize: '15px' }} variant="loanAm">
                    {/* {adjustToLoan ? 
                "واپسی په قرض کی حساب شی" : 
                " یا په قرض کی حساب نه شی"}  */}
                    <span>واپسی په قرض کی حسابوی</span>
                  </Typography>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeRefundDialog}>رد </Button>
          <Button
            onClick={doRefund}
            color="secondary"
            variant="contained"
          >
            تایید
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}